PJQ.views.dailyReports.DailyReportSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Settings'),
        subTemplates: {
            templateBadge: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Survey-Template-Badge')
        },
        maxWidth: 500
    },
    events: {
        'click .btn-report-day': 'reportDayClicked',
        'click .survey-template-edit': 'editTemplate',
        'click .survey-template-delete': 'removeTemplate',
        'click .is-disable-all-notifications': 'disableNotifications',
        'click .settings-save': 'onSave',
        'mouseup .input-adjust-image-size': 'adjustImageClicked'
    },
    afterModalCreated: function () {
        PJQ.app.session.project.fetchDailyReportSettings(_.bind(function (settings) {
            this.model = settings;
            PJQ.app.session.fetchDailyReportTemplates(_.bind(function (templates) {
                this.templates = templates;
                PJQ.app.session.fetchUsers(_.bind(function (contacts) {
                    this.contacts = contacts;
                    this.render()
                }, this));
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            setDefaultValues: true,
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        if (this.model == null) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });

        let surveyName = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_SURVEY_NAME),
            attachmentsName = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_ATTACHMENTS_NAME);
        this.sort = [
            {
                attributes: {
                    name: "Weather",
                    sortNumber: this.model.get('weatherSort')
                }
            },
            {
                attributes: {
                    name: "Work Logs",
                    sortNumber: this.model.get('workLogSort')
                }
            },
            {
                attributes: {
                    name: "Notes",
                    sortNumber: this.model.get('noteSort')
                }
            },
            {
                attributes: {
                    name: "Deliveries",
                    sortNumber: this.model.get('deliverySort')
                }
            },
            {
                attributes: {
                    name: "Communications",
                    sortNumber: this.model.get('communicationSort')
                }
            },
            {
                attributes: {
                    name: "Inspections",
                    sortNumber: this.model.get('inspectionSort')
                }
            },
            {
                attributes: {
                    name: _.size(surveyName) > 0 ? surveyName : "Survey",
                    sortNumber: this.model.get('surveySort')
                }
            },
            {
                attributes: {
                    name: _.size(attachmentsName) > 0 ? attachmentsName : "Attachments",
                    sortNumber: this.model.get('attachmentSort')
                }
            }
        ];

        this.sortTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.export-sort-table'),
            isHideSearch: true,
            rowId: "cid",
            data: this.sort,
            order: [0, 'asc'],
            paging: false,
            columns: [
                {
                    "title": "Sort Order",
                    "data": "attributes.sortNumber",
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data, type, row) {
                        let expenseSort = this.model.get('expenseSort');
                        if (data > expenseSort) {
                            return data - 1
                        } else {
                            return data
                        }
                    }, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false
                }
            ]
        });
        if (this.model != null) {
            this.reportTimePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-report-time'),
                isTimeOnly: true,
                datepickerOptions: {
                    defaultDate: new Date(this.model.get('time'))
                }
            });

            let projectStart = PJQ.app.session.project.get('startDate');
            this.projectStartDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-project-start'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase(),
                    defaultDate: projectStart != null ? PJQ.helpers.dateHelpers.parseDateString(projectStart, false) : null
                }
            });

            let projectEnd = PJQ.app.session.project.get('endDate');
            this.projectEndDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-project-end'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase(),
                    defaultDate: projectEnd != null ? PJQ.helpers.dateHelpers.parseDateString(projectEnd, false) : null
                }
            });

            new PJQ.Alert(this.$('.schedule-settings-alert'), {
                text: 'Any un-submitted reports on work days within the project start and finish dates will be automatically marked as missed after the due time.',
                cookie: PJQ.constants.cookies.NOTIFY_DAILY_REPORTS_PROJECT_START_END
            });

            this.notificationModeSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.notification-mode'),
                hideDisabled: false,
                isMultiple: false,
                isRequired: true,
                isIntChoices: true,
                defaultValue: this.model.get('notificationMode'),
                onChange: _.bind(function () {
                    this.model.set('notificationMode', this.notificationModeSelectPicker.getValue());
                    this.notificationTypeChanged(this.notificationModeSelectPicker.getValue());
                }, this)
            });
            this.notificationTypeChanged(this.notificationModeSelectPicker.getValue());

            this.notificationSettingsPerDay = [];
            _.each(PJQ.constants.date.WEEKDAYNAMES, _.bind(function (day, index) {
                let ns = new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.notification-settings-day-picker[data-day=' + day.bit + ']'),
                    context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                    selectedContact: this.model.notificationSettings.getContactsForDay(day.bit),
                    isSingleChoice: false,
                    emptyNotice: "No Project Contacts Selected",
                    onAdd: _.bind(function (contacts) {
                        _.each(contacts, _.bind(function (contact) {
                            this.model.notificationSettings.addUserForDay(contact.id, day.bit);
                        }, this));
                    }, this),
                    onDelete: _.bind(function (contact) {
                        this.model.notificationSettings.removeUserFromDay(contact.id, day.bit);
                    }, this)
                });

                this.notificationSettingsPerDay.push(ns);
            }, this));
            this.notificationPerDayRefresh();

            this.$('.submitted-email-list').val(this.model.get('submittedEmailList'));

            this.renderTemplatePicker();
            this.checkPixelValue();
        }
    },
    notificationPerDayRefresh: function () {
        _.each(PJQ.constants.date.WEEKDAYNAMES, _.bind(function (day, index) {
            let daySelected = this.$('.btn-report-day[data-value="' + day.bit + '"]').hasClass('btn-success');
            if (daySelected) {
                this.$('.notification-settings-by-day[data-day=' + day.bit + ']').show();
            } else {
                this.$('.notification-settings-by-day[data-day=' + day.bit + ']').hide();
            }
        }, this));
    },
    notificationTypeChanged: function (value) {
        switch (value) {
            case PJQ.constants.dailyReports.notificationModes.DISABLED:
                this.$('.notification-settings-by-day-container, .submitted-email-list-container').hide();
                break;
            case PJQ.constants.dailyReports.notificationModes.PER_USER_DAY:
                this.$('.notification-settings-by-day-container').show();
                this.$('.submitted-email-list-container').show();
                break;
            default:
                this.$('.notification-settings-by-day-container').hide();
                this.$('.submitted-email-list-container').show();
        }
    },
    renderTemplatePicker: function () {
        let notPickedTemplates = _.filter(this.templates.models, _.bind(function (template) {
                return this.model.templates.get(template.id) == null;
            }, this)),
            $picker = $('<select>', {
                class: 'survey-template-picker'
            });

        $picker.append($('<option value="" disabled>Select value</option>'));
        let $newTemplateGroup = $('<optgroup>');
        $newTemplateGroup.append($('<option value="-1">New Template</option>'));
        $picker.append($newTemplateGroup);
        _.each(notPickedTemplates, function (template) {
            $picker.append($('<option>', {
                text: template.get('name'),
                value: template.id
            }));
        });
        this.$('.survey-template-picker-container').html($picker);

        this.templatePicker = new PJQ.inputs.Selectpicker({
            el: $picker,
            isIntChoices: true,
            hideDisabled: true,
            noneSelectedText: 'Select to add template',
            onChange: _.bind(function (templateId) {
                if (templateId === -1) {
                    this.addTemplate();
                } else {
                    let selectedTemplate = this.templates.get(templateId);
                    if (PJQ.app.session.project != null) {
                        selectedTemplate.set('projectId', PJQ.app.session.project.id)
                    }

                    this.model.templates.add(selectedTemplate);
                    this.renderTemplatePicker();
                }
            }, this)
        });

        let $selectedTemplates = this.$('.selected-templates');
        $selectedTemplates.empty();
        _.each(_.sortBy(this.model.templates.models, function (model) {
            return model.get('sortOrder');
        }), _.bind(function (template) {
            this.renderSubTemplate(true, this.options.subTemplates.templateBadge, $selectedTemplates, {
                model: template
            });
        }, this));
    },
    addTemplate: function () {
        let template = new PJQ.models.dailyReports.SurveyTemplate({
            name: "",
            isDefault: false
        });
        new PJQ.views.dailyReports.DailyReportTemplateManagementModal({
            model: template,
            contacts: this.contacts,
            onSave: _.bind(function () {
                this.templates.add(template);
                this.model.templates.add(template);
                this.renderTemplatePicker();
                this.options.onSave();
            }, this),
            onClose: _.bind(function () {
                this.renderTemplatePicker();
            }, this),
        });
    },
    editTemplate: function (e) {
        let template = this.model.templates.get($(e.currentTarget).closest('.survey-template-badge').data('id'));
        new PJQ.views.dailyReports.DailyReportTemplateManagementModal({
            model: template,
            onSave: this.options.onSave,
            contacts: this.contacts,
            onClose: _.bind(function () {
                this.renderTemplatePicker();
            }, this),
            onDelete: _.bind(function () {
                this.templates.remove(template.id);
                this.model.templates.remove(template.id);
                this.renderTemplatePicker();
                this.options.onSave();
            }, this)
        });
    },
    checkPixelValue: function () {
        if ((this.model.get('thumbDimenX') != null || this.model.get('thumbDimenY') != null)) {
            this.$('.input-adjust-image-size').prop('checked', true);
            this.$('.adjust-image-inputs').show("fast");
            this.$('.keep-aspect-ratio').show('fast');
        }
    },
    adjustImageClicked: function () {
        let isChecked = this.$('.input-adjust-image-size').prop('checked');
        !isChecked ? this.$('.adjust-image-inputs').show("fast") : this.$('.adjust-image-inputs').hide("fast");
        !isChecked ? this.$('.keep-aspect-ratio').show("fast") : this.$('.keep-aspect-ratio').hide("fast");
    },
    removeTemplate: function (e) {
        let templateId = $(e.currentTarget).closest('.survey-template-badge').data('id');
        this.model.templates.remove(templateId);
        this.renderTemplatePicker();
    },
    reportDayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('btn-success font-weight-normal selected').addClass('btn-light text-medium');
        } else {
            dayBtn.removeClass('btn-light text-medium').addClass('btn-success font-weight-normal selected');
        }
        this.notificationPerDayRefresh();
    },
    onSave: function () {
        let rows = [];
        for (let i = 0; i < this.sortTable.dataTable.rows().data().length; i++) {
            rows.push(this.sortTable.dataTable.rows().data()[i])
        }
        _.each(rows, function (row) {
            switch (row.attributes.name) {
                case 'Weather':
                    this.model.set('weatherSort', row.attributes.sortNumber);
                    break;
                case 'Work Logs':
                    this.model.set('workLogSort', row.attributes.sortNumber);
                    break;
                case 'Notes':
                    this.model.set('noteSort', row.attributes.sortNumber);
                    break;
                case 'Deliveries':
                    this.model.set('deliverySort', row.attributes.sortNumber);
                    break;
                case 'Surveys':
                    this.model.set('surveySort', row.attributes.sortNumber);
                    break;
                case 'Attachments':
                    this.model.set('attachmentSort', row.attributes.sortNumber);
                    break;
            }
        }, this);

        let isExportWorkLogs = this.$('.input-export-work-logs').prop('checked'),
            isExportNotes = this.$('.input-export-notes').prop('checked'),
            isExportExpenses = this.$('.input-export-expenses').prop('checked'),
            isExportSurvey = this.$('.input-export-survey').prop('checked'),
            isExportDeliveries = this.$('.input-export-deliveries').prop('checked'),
            isExportCommunications = this.$('.input-export-communications').prop('checked'),
            isExportInspections = this.$('.input-export-inspections').prop('checked'),
            isExportAttachments = this.$('.input-export-attachments').prop('checked'),
            isExportWeather = this.$('.input-export-weather').prop('checked'),
            isHideUnansweredSurveyItems = this.$('.input-hide-unanswered-survey-questions').prop('checked'),
            isLockReportAfterSubmit = this.$('.input-submit-lock-report').prop('checked'),
            reportTime = this.reportTimePicker.getValue(),
            workDaysBit = 0,
            submittedEmailList = this.$('.submitted-email-list').val(),
            notificationMode = this.notificationModeSelectPicker.getValue(),
            notificationSettings = this.model.notificationSettings.models,
            isShowAttachmentUploadedBy = this.$('.input-show-attachment-uploader').prop('checked'),
            thumbDimenX = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-x').val() : null,
            thumbDimenY = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-y').val() : null,
            isKeepThumbAspectRatio = this.$('.input-keep-aspect').prop('checked');
        this.$('.btn-report-day.selected').each(function () {
            workDaysBit += parseInt($(this).data('value'));
        });

        if (isLockReportAfterSubmit) {
            PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT, isLockReportAfterSubmit)
        } else {
            PJQ.app.session.preferences.deletePref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT)
        }

        if (notificationMode === PJQ.constants.dailyReports.notificationModes.DISABLED) {
            submittedEmailList = '';
            // TODO: clear out any custom per-day notifications as well
        }

        if (_.size(this.model.templates) === 0) {
            this.templatePicker.showError("You must pick at least one template");
            return;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.submitted-email-list'), true);
        if (submittedEmailList) {
            if (!PJQ.helpers.validators.validateEmail(submittedEmailList, true).success) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.submitted-email-list'), false);
                return;
            }
        }

        //We have to be sure we save the project and the daily report settings before we callback to onSave
        //The onSave is likely waiting to get a new list of reports to refresh their statuses
        let loader = new PJQ.Loader(this.$('.modal-content')),
            startDate = this.projectStartDatePicker.getValue(),
            finishDate = this.projectEndDatePicker.getValue(),
            project = PJQ.app.session.project;
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'dates'
                }
            ]),
            data: {
                projectId: project.id,
                startDate: startDate,
                endDate: finishDate
            }
        }).put().done(_.bind(function () {
            PJQ.app.session.project.set({
                startDate: startDate,
                endDate: finishDate
            })
            this.model.save({
                workDays: workDaysBit,
                time: reportTime,
                isExportWorkLogs: isExportWorkLogs,
                isExportNotes: isExportNotes,
                isExportExpenses: isExportExpenses,
                isExportSurvey: isExportSurvey,
                isExportDeliveries: isExportDeliveries,
                isExportCommunications: isExportCommunications,
                isExportInspections: isExportInspections,
                isExportAttachments: isExportAttachments,
                isExportWeather: isExportWeather,
                isHideUnansweredSurveyItems: isHideUnansweredSurveyItems,
                isLockReportAfterSubmit: isLockReportAfterSubmit,
                isShowAttachmentUploadedBy: isShowAttachmentUploadedBy,
                thumbDimenX: thumbDimenX,
                thumbDimenY: thumbDimenY,
                isKeepThumbAspectRatio: isKeepThumbAspectRatio,
                submittedEmailList: submittedEmailList,
                notificationMode: notificationMode,
                notificationSettings: notificationSettings,
            }, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave();
                    }
                    this.removeModal();
                }, this),
                error: function () {
                    loader.remove();
                    //todo: toast error
                }
            });
        }, this));
    }
});

PJQ.views.dailyReports.DailyReportTemplateManagementModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Template-Management'),
        subTemplates: {
            item: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Template-Question-Edit')
        },
        maxWidth: 600,
        onSave: _.noop,
        onDelete: _.noop
    },
    events: {
        'click .btn-delete-template-question': 'removeQuestion',
        'click .btn-template-question-day': 'questionDayClicked',
        'click .btn-add-template-question': 'addQuestion',
        'click .template-delete': 'onDelete',
        'click .template-save': 'onSave',
        'click .btn-survey-day': 'surveyDayClicked',
        'click .template-close': 'onClose'
    },
    afterModalCreated: function () {
        this.model.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
        this.contacts = this.options.contacts;
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            contacts: this.contacts
        };
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-template-default'),
            defaultValue: this.model.get('isDefault'),
            onChange: _.bind(function (isDefault) {
                this.model.set('isDefault', isDefault === 'true')
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-template-contacts'),
            isMultiple: true,
            hideDisabled: false,
            isIntChoices: true,
            defaultValue: this.model.get('assignees') != null ? _.map(this.model.get('assignees'), function (assignee) {
                return assignee.id;
            }) : null,
            noneSelectedText: "All Project Contacts",
            onChange: _.bind(function (value) {
                let newAssignees;
                if (_.size(value) > 0) {
                    newAssignees = _.map(value, function (id) {
                        return {
                            id: id
                        };
                    });
                } else {
                    newAssignees = null;
                }
                this.model.set('assignees', newAssignees);
            }, this)
        });

        this.renderQuestions();
    },
    surveyDayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('btn-success font-weight-normal selected').addClass('btn-light text-medium');
        } else {
            dayBtn.removeClass('btn-light text-medium').addClass('btn-success font-weight-normal selected');
        }
    },
    renderQuestions: function () {
        let $questions = this.$('.template-questions');
        $questions.empty();
        if (_.size(this.model.questions.models) > 0) {
            _.each(_.sortBy(_.filter(this.model.questions.models, function (model) {
                return !model.get('isDeleted');
            }), function (model) {
                return model.get('sortOrder');
            }), _.bind(function (question, index) {
                this.renderQuestion(question, index);
            }, this));
        } else {
            $questions.append($('<div>', {
                class: 'no-questions-text fs-16 font-weight-light text-muted text-align-center mt-2 mb-2',
                text: 'No questions added yet'
            }));
        }
    },
    renderQuestion: function (question, index) {
        let $questions = this.$('.template-questions');
        $questions.find('.no-questions-text').remove();
        this.renderSubTemplate(true, this.options.subTemplates.item, $questions, {
            model: question,
            index: index
        }, _.bind(function ($question) {
            new PJQ.inputs.Selectpicker({
                el: $question.find('.select-question-days'),
                isMultiple: true,
                noneSelectedText: 'No Days',
                isIntChoices: true,
                onChange: function (days) {
                    question.set('weekdays', _.reduce(days, function (total, day) {
                        return total + day;
                    }, 0));
                }
            });
        }, this))
    },
    questionDayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('btn-success font-weight-normal selected').addClass('btn-light text-medium');
        } else {
            dayBtn.removeClass('btn-light text-medium').addClass('btn-success font-weight-normal selected');
        }
    },
    removeQuestion: function (e) {
        let $question = $(e.currentTarget).closest('.template-question'),
            cid = $(e.currentTarget).closest('.template-question').data('cid'),
            question = this.model.questions.get(cid);

        if (question.id > 0) {
            question.set('isDeleted', true);
        } else {
            this.model.questions.remove(cid);
        }
        $question.remove();
        _.each(this.model.questions.models, _.bind(function (question) {
            let $question = this.$('.template-question[data-cid="' + question.cid + '"]');
            question.set({
                question: $question.find('.input-template-question-question').val(),
                isAllowNote: $question.find('.input-template-question-allow-note').prop('checked'),
                isAllowYesNo: $question.find('.input-template-question-allow-yes-no').prop('checked'),
                isRequired: $question.find('.input-template-question-required').prop('checked')
            });
        }, this));
        this.render();
    },
    addQuestion: function () {
        let newQuestion = new PJQ.models.dailyReports.SurveyTemplateQuestion({
            surveyTemplateId: this.model.id,
            question: "",
            sortOrder: _.size(this.model.questions) + 1,
            isAllowNote: true,
            isAllowYesNo: true
        });
        this.model.questions.add(newQuestion);
        this.renderQuestion(newQuestion)
    },
    onDelete: function (e) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?  This will also remove it from any projects it is on.",
            onDelete: _.bind(function () {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.model.destroy({
                    success: _.bind(function () {
                        this.options.onDelete();
                        this.removeModal();
                    }, this),
                    error: function () {
                        loader.remove();
                        //todo: toast error
                    }
                })
            }, this)
        });
    },
    onClose: function () {
        if (this.options.onClose) {
            this.options.onClose();
            this.removeModal();
        }
    },
    onSave: function () {
        let $templateName = this.$('.input-template-name'),
            templateName = $templateName.val();
        if (_.size(templateName) === 0) {
            PJQ.helpers.inputHelpers.setInputError($templateName, false);
            return;
        } else {
            PJQ.helpers.inputHelpers.setInputError($templateName, true);
        }
        let surveyDaysBit = 0;
        this.$('.btn-survey-day.selected').each(function () {
            surveyDaysBit += parseInt($(this).data('value'));
        });

        let loader = new PJQ.Loader(this.$('.modal-content'));
        _.each(this.model.questions.models, _.bind(function (question) {
            let $question = this.$('.template-question[data-cid="' + question.cid + '"]');
            question.set({
                question: $question.find('.input-template-question-question').val(),
                isAllowNote: $question.find('.input-template-question-allow-note').prop('checked'),
                isAllowYesNo: $question.find('.input-template-question-allow-yes-no').prop('checked'),
                isRequired: $question.find('.input-template-question-required').prop('checked')
            });
        }, this));
        this.model.save({
            projectId: PJQ.app.session.project != null ? PJQ.app.session.project.id : null,
            name: templateName,
            surveyDays: surveyDaysBit > 0 ? surveyDaysBit : null
        }, {
            success: _.bind(function () {
                this.options.onSave();
                this.removeModal();
            }, this),
            error: function () {
                loader.remove();
                //todo: toast error
            }
        });

    }
});

PJQ.views.dailyReports.DailyReportExportSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Export-Settings'),
        maxWidth: 600,
        onSave: _.noop
    },
    events: {
        'click .settings-save': 'onSave',
        'mouseup .input-adjust-image-size': 'adjustImageClicked'
    },
    afterModalCreated: function () {
        PJQ.app.session.project.fetchDailyReportSettings(_.bind(function (settings) {
            this.model = settings;
            PJQ.app.session.fetchDailyReportTemplates(_.bind(function (templates) {
                this.templates = templates;
                this.render()
            }, this));
        }, this));
    },
    beforeRender: function () {
        this.renderData = {
            setDefaultValues: true,
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model == null) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });

        let prefs = PJQ.app.session.project != null ? PJQ.app.session.project.preferences : PJQ.app.session.preferences,
            surveyName = prefs.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_SURVEY_NAME),
            attachmentsName = prefs.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_ATTACHMENTS_NAME);
        this.sort = [
            {
                attributes: {
                    name: "Weather",
                    sortNumber: this.model.get('weatherSort')
                }
            },
            {
                attributes: {
                    name: "Work Logs",
                    sortNumber: this.model.get('workLogSort')
                }
            },
            {
                attributes: {
                    name: "Notes",
                    sortNumber: this.model.get('noteSort')
                }
            },
            {
                attributes: {
                    name: "Deliveries",
                    sortNumber: this.model.get('deliverySort')
                }
            },
            {
                attributes: {
                    name: "Communications",
                    sortNumber: this.model.get('communicationSort')
                }
            },
            {
                attributes: {
                    name: "Inspections",
                    sortNumber: this.model.get('inspectionSort')
                }
            },
            {
                attributes: {
                    name: _.size(surveyName) > 0 ? surveyName : "Survey",
                    sortNumber: this.model.get('surveySort')
                }
            },
            {
                attributes: {
                    name: _.size(attachmentsName) > 0 ? attachmentsName : "Attachments",
                    sortNumber: this.model.get('attachmentSort')
                }
            }
        ];

        this.sortTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.export-sort-table'),
            isHideSearch: true,
            rowId: "cid",
            data: this.sort,
            order: [0, 'asc'],
            paging: false,
            columns: [
                {
                    "title": "Sort",
                    "data": "attributes.sortNumber",
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data) {
                        let expenseSort = this.model.get('expenseSort');
                        if (data > expenseSort) {
                            return data - 1
                        } else {
                            return data
                        }
                    }, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false
                }
            ]
        });
        this.checkPixelValue();
    },
    checkPixelValue: function () {
        if ((this.model.get('thumbDimenX') != null || this.model.get('thumbDimenY') != null || this.model.get('isKeepThumbAspectRatio') === true)) {
            $('.input-adjust-image-size').prop('checked', true);
            $('.adjust-image-inputs').show("fast");
            $('.keep-aspect-ratio').show('fast');
        }
    },
    adjustImageClicked: function () {
        let isChecked = $('.input-adjust-image-size').prop('checked');
        !isChecked ? $('.adjust-image-inputs').show("fast") : $('.adjust-image-inputs').hide("fast");
        !isChecked ? $('.keep-aspect-ratio').show("fast") : $('.keep-aspect-ratio').hide("fast")
    },
    onSave: function () {
        let rows = [];
        for (let i = 0; i < this.sortTable.dataTable.rows().data().length; i++) {
            rows.push(this.sortTable.dataTable.rows().data()[i])
        }
        _.each(rows, function (row) {
            switch (row.attributes.name) {
                case 'Weather':
                    this.model.set('weatherSort', row.attributes.sortNumber);
                    break;
                case 'Work Logs':
                    this.model.set('workLogSort', row.attributes.sortNumber);
                    break;
                case 'Notes':
                    this.model.set('noteSort', row.attributes.sortNumber);
                    break;
                case 'Deliveries':
                    this.model.set('deliverySort', row.attributes.sortNumber);
                    break;
                case 'Communications':
                    this.model.set('communicationSort', row.attributes.sortNumber);
                    break;
                case 'Inspections':
                    this.model.set('inspectionSort', row.attributes.sortNumber);
                    break;
                case 'Surveys':
                    this.model.set('surveySort', row.attributes.sortNumber);
                    break;
                case 'Attachments':
                    this.model.set('attachmentSort', row.attributes.sortNumber);
                    break;
            }
        }, this);
        let isExportWorkLogs = this.$('.input-export-work-logs').prop('checked'),
            isExportNotes = this.$('.input-export-notes').prop('checked'),
            isExportExpenses = this.$('.input-export-expenses').prop('checked'),
            isExportSurvey = this.$('.input-export-survey').prop('checked'),
            isExportDeliveries = this.$('.input-export-deliveries').prop('checked'),
            isExportCommunications = this.$('.input-export-communications').prop('checked'),
            isExportInspections = this.$('.input-export-inspections').prop('checked'),
            isExportAttachments = this.$('.input-export-attachments').prop('checked'),
            isExportWeather = this.$('.input-export-weather').prop('checked'),
            isHideUnansweredSurveyItems = this.$('.input-hide-unanswered-survey-questions').prop('checked'),
            thumbDimenX = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-x').val() : null,
            thumbDimenY = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-y').val() : null,
            isShowAttachmentUploadedBy = this.$('.input-show-attachment-uploader').prop('checked'),
            isKeepThumbAspectRatio = this.$('.input-keep-aspect').prop('checked');

        this.model.set({
            isExportWorkLogs: isExportWorkLogs,
            isExportNotes: isExportNotes,
            isExportExpenses: isExportExpenses,
            isExportSurvey: isExportSurvey,
            isExportDeliveries: isExportDeliveries,
            isExportCommunications: isExportCommunications,
            isExportInspections: isExportInspections,
            isExportAttachments: isExportAttachments,
            isExportWeather: isExportWeather,
            isHideUnansweredSurveyItems: isHideUnansweredSurveyItems,
            thumbDimenX: thumbDimenX,
            thumbDimenY: thumbDimenY,
            isShowAttachmentUploadedBy: isShowAttachmentUploadedBy,
            isKeepThumbAspectRatio: isKeepThumbAspectRatio
        });

        this.options.onSave(this.model);
        this.removeModal();
    }
});
